import { render, staticRenderFns } from "./Stowages.vue?vue&type=template&id=1356ecac&"
import script from "./Stowages.vue?vue&type=script&lang=js&"
export * from "./Stowages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports